import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContractList from "./ContractList";
import ContractTabs from "./ContractTabs";
import SubscriptionModal from "./SubscriptionModal";
import ContractDetailModal from "./ContractDetailModal";
import ProductModal from "./ProductModal";
import ResultsModal from "./ResultsModal";
import LineageModal from "./LineageModal";
import "./LandingPage.scss";
import axios from "axios";
import heartLoading from "../../../assests/heartLoading.gif";
import { toast, Toaster } from "react-hot-toast";
import LineageTransformationModal from "./LineageTransformation/LineageTransformationModal";
import { ANALYTICAL_PRODUCT } from "../../../constants/Dashboard";
import FilterDrawer from "./FilterDrawer";
import KpiDiscovery from "./KpiDiscovery";
import {
  RotateCcw,
  Filter,
  Database,
  FileText,
  Target,
  ShoppingCart,
  ShoppingBag,
} from "lucide-react";
import ReportSubscriptionModal from "./ReportSubscriptionModal";
import { BookOpen } from "lucide-react";
import GlossaryDiscovery from "./GlossaryDiscovery";
import { useFeatureFlag } from "../../../context/FeatureFlagContext";
import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CLEAR_CART,
} from "../../../redux/domainAddToCart/domainAddToCart.type";
import AssetDetailsModal from "./AssetDetailsModal";

const LandingPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.domainAddToCart);
  const CUSTOM_TAB = "custom";

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [subscribedTables, setSubscribedTables] = useState([]);
  const [solutionData, setSolutionData] = useState([]);
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
  const [showReportSubscriptionForm, setShowReportSubscriptionForm] =
    useState(false);
  const [selectedTable, setSelectedTable] = useState(null);
  const [showContractModal, setShowContractModal] = useState(false);
  const [selectedContractForView, setSelectedContractForView] = useState(null);
  const [contractDetails, setContractDetails] = useState(null);
  const [contractLoading, setContractLoading] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState([]); // Default selection
  const [filterReset, setFilterReset] = useState(false);
  // Product details popup state
  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProductForView, setSelectedProductForView] = useState(null);
  const [productLoading, setProductLoading] = useState(false);
  const [kpiData, setKpiData] = useState([]);
  const [kpiTotalCount, setKpiTotalCount] = useState(0);
  // Result popup state
  const [showResultModal, setShowResultModal] = useState(false);
  const [selectedResultForView, setSelectedResultForView] = useState(null);
  const [activeResultTab, setActiveResultTab] = useState("profile"); // 'profile', 'quality', or 'remediation'

  // Lineage popup state
  const [showLineageModal, setShowLineageModal] = useState(false);
  const [selectedLineageForView, setSelectedLineageForView] = useState(null);
  const [transformLineageAsset, setTransformLineageAsset] = useState(null);
  const [kpiSortConfig, setKpiSortConfig] = useState({
    key: null,
    order: null,
  });

  // Profiling results state
  const [profilingResults, setProfilingResults] = useState(null);
  const [profilingLoading, setProfilingLoading] = useState(false);

  // DQ results state
  const [dqResults, setDqResults] = useState(null);
  const [dqLoading, setDqLoading] = useState(false);

  // Asset details popup state
  const [showAssetModal, setShowAssetModal] = useState(false);
  const [selectedAssetForView, setSelectedAssetForView] = useState(null);
  const [assetData, setAssetData] = useState(null);
  const [assetLoading, setAssetLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("assets"); // default active tab

  // Filter state with IDs for hierarchical filtering
  const [parentDomain, setParentDomain] = useState("All Parent Domains");
  const [parentDomainId, setParentDomainId] = useState(null);
  const [domain, setDomain] = useState("All Domains");
  const [domainId, setDomainId] = useState(null);
  const [subDomain, setSubDomain] = useState("All Sub Domains");
  const [subDomainId, setSubDomainId] = useState(null);
  const [product, setProduct] = useState("All Products");

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // API data states
  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState(
    "Hang tight! The resources are loading..."
  );
  const [searchLoading, setSearchLoading] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [error, setError] = useState(null);
  const [productDetails, setProductDetails] = useState([]);
  const [assetName, setAssetName] = useState("");
  const [subscribableProducts, setSubscribableProducts] = useState();
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const isGrossaryFeatureEnabled  = useFeatureFlag("grossaryDiscovery");
const [maxHits, setMaxHits] = useState(null);

  // Filter options from API - updated for hierarchical structure
  const [filterOptions, setFilterOptions] = useState({
    parentDomains: [],
    domains: [],
    subDomains: [],
    products: [],
    productDataLayer: [],
    lineOfBusiness: [],
    reportType: [],
    cloudProvider: [],
    tags: [],
    marketCoverage: [],
    expectedUserBase: { min: 0, max: 10000 },
    dqRating: { min: 0, max: 100 },
    productOwner: [],
    assetSource: [],
    reportOwner: [],
  });

  // Store the full hierarchical filters data from API
  const [hierarchicalFilters, setHierarchicalFilters] = useState(null);

  const [subscriptionForm, setSubscriptionForm] = useState({
    productName: "",
    projectCode: "",
    readerGroup: "",
    usageDuration: "3months",
    usageDescription: "",
    notificationEmail: "",
    acceptTerms: false,
    source: "DATAPULSE",
  });

  const [allFieldsValid, setAllFieldsValid] = useState(true);
  const [formTouched, setFormTouched] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [allSelectedFilters, setAllSelectedFilters] = useState({
    parentDomain: [],
    domain: [],
    subDomain: [],
    product: [],
    productDataLayer: [],
    lineOfBusiness: [],
    reportType: [],
    cloudProvider: [],
    tags: [],
    parentRegion: [],
    region: [],
    country: [],
    expectedUserBase: [0, 10000],
    dqRating: [0, 100],
    productOwner: [],
    assetSource: [],
    reportOwner: [],
    searchBy: "tables",
    tables: [],
    columns: [],
  });

  // Redux Cart Functions
  const mapAssetToCartItem = (asset) => ({
    id: asset.data_asset_id || asset.id,
    name: asset.data_asset_name || asset.name,
    productName: asset.product_name || "",
  });

  const isSelected = (assetId) => cartItems.some((item) => item.id === assetId);

  const handleSelectSingleAsset = (asset) => {
    if (isSelected(asset.data_asset_id || asset.id)) {
      dispatch({
        type: REMOVE_FROM_CART,
        payload: [asset.data_asset_id || asset.id],
      });
    } else {
      dispatch({
        type: ADD_TO_CART,
        payload: [mapAssetToCartItem(asset)],
      });
    }
  };

  // Update allFieldsValid whenever form or errors change
  useEffect(() => {
    const isValid =
      subscriptionForm.productName &&
      subscriptionForm.readerGroup &&
      subscriptionForm.usageDuration &&
      subscriptionForm.usageDescription &&
      subscriptionForm.notificationEmail &&
      Object.keys(formErrors).length === 0;
    setAllFieldsValid(isValid);
  }, [subscriptionForm, formErrors]);

  const handleApplyAllFilters = (allFilters) => {
    // console.log("Received all filters from drawer:", allFilters);

    setAllSelectedFilters(allFilters);
    if (allFilters.searchValue) {
      setSearchQuery(allFilters.searchValue);
    }

    setCurrentPage(1);
    setFilterLoading(true);

    const payload = {
      page: 1,
      pageSize: pageSize,

      parentDomain: allFilters.parentDomain || [],
      domain: allFilters.domain || [],
      subDomain: allFilters.subDomain || [],
      product: allFilters.product || [],

      searchValue: allFilters.searchValue || "",

      productDataLayer: allFilters.productDataLayer || [],
      lineOfBusiness: allFilters.lineOfBusiness || [],
      reportType: allFilters.reportType || [],
      cloudProvider: allFilters.cloudProvider || [],
      tags: allFilters.tags || [],

      // Search by tables/columns
      searchBy: allFilters.searchBy || "tables",
      tables: allFilters.tables || [],
      columns: allFilters.columns || [],
      cdeEnabled: allFilters.cdeEnabled || false,

      marketRegion: allFilters.marketRegion || [],
      parentRegion: allFilters.parentRegion || [],
      country: allFilters.country || [],

      expectedUserBase: allFilters.expectedUserBase || [0, 10000],
      dqRating: allFilters.dqRating || [0, 100],

      // Ownership filters
      productOwner: allFilters.productOwner || [],
      assetSource: allFilters.assetSource || [],
      reportOwner: allFilters.reportOwner || [],
    };

    fetchDataDiscovery(payload).finally(() => {
      setFilterLoading(false);
    });
  };

  const applyFilters = () => {
    let filtered = [...apiData];

    // Filter by parent domain
    if (parentDomain !== "All Parent Domains") {
      filtered = filtered.filter(
        (item) => item.parent_domain_name === parentDomain
      );
    }

    // Filter by domain
    if (domain !== "All Domains") {
      filtered = filtered.filter((item) => item.domain_name === domain);
    }
    // Filter by sub domain
    if (subDomain !== "All Sub Domains") {
      filtered = filtered.filter((item) => item.sub_domain_name === subDomain);
    }

    // Filter by product
    if (product !== "All Products") {
      filtered = filtered.filter((item) => {
        if (item.data_layer === "analyticalProduct") {
          return item.product_name === product;
        }
        return item.product_name === product;
      });
    }

    setFilteredData(filtered);
  };

  // Fetch data from API when component mounts
  const fetchDataDiscovery = async (searchPayload = null) => {
    // setLoading(true);
    try {
      // Process search query - convert spaces to underscores and trim
      const processedSearchQuery = searchQuery
        ? searchQuery.trim().replace(/\s+/g, "_")
        : "";

      const payload = searchPayload || {
        parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
        domain: domain === "All Domains" ? "" : domain,
        subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
        product: product === "All Products" ? "" : product,
        searchValue: processedSearchQuery,
        page: currentPage,
        pageSize: pageSize,
      };

      // Add ownerName or subscribedBy based on active tab
      if (activeTab === "myContracts") {
        payload.ownerName = localStorage.getItem("userId") || "";
      } else if (activeTab === "mySubscriptions") {
        payload.subscribedBy = localStorage.getItem("userId") || "";
      }

      // Use different API endpoint based on active tab
      let apiEndpoint;
      if (activeTab === "myContracts") {
        apiEndpoint = `${process.env.REACT_APP_API_URL}/my-data-contracts-results`;
      } else if (activeTab === "mySubscriptions") {
        apiEndpoint = `${process.env.REACT_APP_API_URL}/my-subscriptions`;
      } else if (activeTab === "reports") {
        apiEndpoint = `${process.env.REACT_APP_API_URL}/analytical-products-discovery`;
      } else {
        if (selectedTab === "assets") {
          apiEndpoint = `${process.env.REACT_APP_API_URL}/data-discovery-results`;
        } else {
          apiEndpoint = `${process.env.REACT_APP_API_URL}/analytical-products-discovery`;
        }
      }

      const response = await axios.post(apiEndpoint, payload);
      if (
        response.data &&
        (response.data.data !== undefined ||
          response.data.analyticalProducts !== undefined)
      ) {
        const data =
          selectedTab === "report"
            ? response.data.analyticalProducts || []
            : response.data.data || [];
        let dataWithType;
        if (selectedTab === "report") {
          dataWithType = data.map((item) => ({
            ...item,
            type: "analyticalProduct",
          }));
          setSolutionData(data);
        } else {
          dataWithType = data.map((item) => ({
            ...item,
            type: "dataAsset",
          }));
        }

        setApiData(dataWithType);

        // Handle filter options from API response -
        if (response.data.filters) {
          const filters = response.data.filters;

          // Store the full hierarchical filters data
          setHierarchicalFilters(filters);

          // Extract parent domains (handle both snake_case and camelCase)
          const parentDomainsData =
            filters.parent_domains || filters.parentDomains || [];
          const parentDomains = parentDomainsData.map((pd) => pd.parent_domain);

          // Get ALL domains from ALL parent domains
          const allDomains = [];
          parentDomainsData.forEach((pd) => {
            (pd.domains || []).forEach((d) => {
              if (!allDomains.includes(d.domain)) {
                allDomains.push(d.domain);
              }
            });
          });

          // Get ALL sub domains from ALL domains
          const allSubDomains = [];
          parentDomainsData.forEach((pd) => {
            (pd.domains || []).forEach((d) => {
              (d.sub_domains || []).forEach((sd) => {
                if (!allSubDomains.includes(sd.sub_domain)) {
                  allSubDomains.push(sd.sub_domain);
                }
              });
            });
          });

          // Get ALL products from ALL sub domains
          const allProducts = [];
          parentDomainsData.forEach((pd) => {
            (pd.domains || []).forEach((d) => {
              (d.sub_domains || []).forEach((sd) => {
                (sd.products || []).forEach((p) => {
                  if (!allProducts.includes(p)) {
                    allProducts.push(p);
                  }
                });
              });
            });
          });

          // Set ALL options
          setFilterOptions({
            parentDomains: parentDomains,
            domains: allDomains,
            subDomains: allSubDomains,
            products: allProducts,
            // Handle both possible field names from backend
            productDataLayer:
              filters.productDataLayer || filters.product_data_layer || [],
            lineOfBusiness:
              filters.lineOfBusiness || filters.line_of_business || [],
            reportType: filters.reportType || filters.report_type || [],
            cloudProvider:
              filters.cloudProvider || filters.cloud_provider || [],
            tags: filters.tags || [],
            marketCoverage:
              filters.marketCoverage || filters.market_coverage || [],
            expectedUserBase: filters.expectedUserBase ||
              filters.expected_user_base || { min: 0, max: 10000 },
            dqRating: filters.dqRating ||
              filters.dq_rating || { min: 0, max: 100 },
            productOwner: filters.productOwner || filters.product_owner || [],
            assetSource: filters.assetSource || filters.asset_source || [],
            reportOwner: filters.reportOwner || filters.report_owner || [],
          });
        }

        // Handle pagination data from API response
        if (response.data.pagination) {
          setTotalCount(response.data.pagination.totalCount);
          setTotalPages(response.data.pagination.totalPages);
          setCurrentPage(response.data.pagination.page);
          setPageSize(response.data.pagination.pageSize);
        } else {
          // Fallback pagination if API doesn't provide it
          const dataLength = response.data.data ? response.data.data.length : 0;
          setTotalCount(dataLength);
          setTotalPages(Math.ceil(dataLength / pageSize));
          setCurrentPage(1);
          // Keep existing pageSize
        }

        // Don't set filteredData here - let applyFilters handle it with new data
      } else {
        setApiData([]);
        setFilteredData([]); // Clear filtered data when API returns no data
        setTotalCount(0);
        setTotalPages(0);
        setCurrentPage(1);
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again.");
      setApiData([]);
      setFilteredData([]); // Clear filtered data on error
      setTotalCount(0);
      setTotalPages(0);
      setCurrentPage(1);
    } finally {
      setLoading(false);
      // API call completed - no fallback data needed
    }
  };
  const fetchKpiData = async (sortBy = null, sortOrder = null) => {
    try {
      let url = `${process.env.REACT_APP_API_URL}/kpi/all`;
      if (sortBy && sortOrder) {
        url += `?sort_by=${sortBy}&sort_order=${sortOrder}`;
      }

      const response = await axios.get(url);
      setKpiData(response.data?.data || []);
      setKpiTotalCount(response.data?.total_count || 0);
    } catch (err) {
      console.error("KPI API error", err);
      setKpiData([]);
      setKpiTotalCount(0);
    }
  };

  const handleKpiSortChange = (sortBy, sortOrder) => {
    setKpiSortConfig({ key: sortBy, order: sortOrder });

    if (sortOrder === null) {
      fetchKpiData(null, null);
    } else {
      fetchKpiData(sortBy, sortOrder);
    }
  };

  // Fetch subscribable products
  useEffect(() => {
    const fetchSubscribableProducts = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/products/subscribable`
      );
      if (response.data) {
        setSubscribableProducts(response.data);
      }
    };
    fetchSubscribableProducts();
  }, []);

  // Fetch data from API when component mounts or when active tab changes
  useEffect(() => {
    if (selectedTab === "CUSTOM_TAB") {
      return;
    }
    setLoading(true);
    fetchDataDiscovery();
  }, [activeTab, selectedTab]);
  useEffect(() => {
    if (selectedTab === "CUSTOM_TAB") {
      setLoading(true);
      fetchKpiData().finally(() => setLoading(false));
    }
  }, [selectedTab]);

  useEffect(() => {
    fetchDataDiscovery();
  }, [filterReset]);

  // Effect to update filtered data when filters change (local filtering only)
  useEffect(() => {
    // Only apply filters locally when filters change, don't call API
    applyFilters();
  }, [parentDomain, domain, subDomain, product]);

  // Effect to apply current filters when apiData changes (after API calls)
  useEffect(() => {
    applyFilters();
  }, [apiData]);

  // Debug effect to monitor loading state changes
  useEffect(() => {}, [searchLoading, filterLoading]);

  const performSearch = async () => {
    setCurrentPage(1);
    setSearchLoading(true);

    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    // ✅ Uses allSelectedFilters to preserve ALL filters
    const payload = {
      page: 1,
      pageSize: pageSize,

      parentDomain: allSelectedFilters.parentDomain || [],
      domain: allSelectedFilters.domain || [],
      subDomain: allSelectedFilters.subDomain || [],
      product: allSelectedFilters.product || [],

      searchValue: processedSearchQuery,

      productDataLayer: allSelectedFilters.productDataLayer || [],
      lineOfBusiness: allSelectedFilters.lineOfBusiness || [],
      reportType: allSelectedFilters.reportType || [],
      cloudProvider: allSelectedFilters.cloudProvider || [],
      tags: allSelectedFilters.tags || [],
      searchBy: allSelectedFilters.searchBy || "tables",
      tables: allSelectedFilters.tables || [],
      columns: allSelectedFilters.columns || [],
      cdeEnabled: allSelectedFilters.cdeEnabled || false,
      marketRegion: allSelectedFilters.region || [],
      parentRegion: allSelectedFilters.parentRegion || [],
      country: allSelectedFilters.country || [],
      expectedUserBase: allSelectedFilters.expectedUserBase || [0, 10000],
      dqRating: allSelectedFilters.dqRating || [0, 100],
      productOwner: allSelectedFilters.productOwner || [],
      assetSource: allSelectedFilters.assetSource || [],
      reportOwner: allSelectedFilters.reportOwner || [],
    };

    try {
      await fetchDataDiscovery(payload);
    } catch (error) {
    } finally {
      setSearchLoading(false);
    }
  };

  // Handle search submission (Enter key)
  const handleSearchSubmit = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (searchQuery.trim()) {
        performSearch();
      } else {
        // If search is empty, fetch all data with current filters
        setSearchLoading(true);
        fetchDataDiscovery().finally(() => {
          setSearchLoading(false);
        });
      }
    }
  };

  // Handle page change - make API call for pagination
  const handlePageChange = async (newPage) => {
    setLoading(true);
    setCurrentPage(newPage);

    // Process search query - convert spaces to underscores and trim
    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: product === "All Products" ? "" : product,
      searchValue: processedSearchQuery,
      page: newPage,
      pageSize: pageSize,
    };

    await fetchDataDiscovery(payload);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  // Handle parent domain change - cascade to other filters
  const handleParentDomainChange = (event) => {
    const newParentDomain = event.target.value;
    setParentDomain(newParentDomain);

    // Reset other filters when parent domain changes
    if (newParentDomain === "All Parent Domains") {
      setDomain("All Domains");
      setSubDomain("All Sub Domains");
      setProduct("All Products");
      setParentDomainId(null);
      setDomainId(null);
      setSubDomainId(null);
    } else {
      // Find related domains, sub domains, and products for this parent domain
      if (hierarchicalFilters && hierarchicalFilters.parent_domains) {
        const selectedParentDomain = hierarchicalFilters.parent_domains.find(
          (pd) => pd.parent_domain === newParentDomain
        );

        if (selectedParentDomain) {
          setParentDomainId(selectedParentDomain.parent_domain_id);

          const relatedDomains = selectedParentDomain.domains.map(
            (d) => d.domain
          );

          // Auto-select domain if only one option available
          if (relatedDomains.length === 1) {
            setDomain(relatedDomains[0]);
            setDomainId(selectedParentDomain.domains[0].domain_id);

            // Also auto-select sub domain and product if only one option
            const selectedDomain = selectedParentDomain.domains[0];
            const domainSubDomains = selectedDomain.sub_domains.map(
              (sd) => sd.sub_domain
            );

            if (domainSubDomains.length === 1) {
              setSubDomain(domainSubDomains[0]);
              setSubDomainId(selectedDomain.sub_domains[0].sub_domain_id);

              const selectedSubDomain = selectedDomain.sub_domains[0];
              const subDomainProducts = selectedSubDomain.products;

              if (subDomainProducts.length === 1) {
                setProduct(subDomainProducts[0]);
              } else {
                setProduct("All Products");
              }
            } else {
              setSubDomain("All Sub Domains");
              setSubDomainId(null);
              setProduct("All Products");
            }
          } else {
            setDomain("All Domains");
            setDomainId(null);
            setSubDomain("All Sub Domains");
            setSubDomainId(null);
            setProduct("All Products");
          }
        }
      }
    }

    // Reset to page 1 when filters change
    setCurrentPage(1);

    // Make API call with new filter - show loading in contracts list area
    setFilterLoading(true);

    // Determine the actual values to send in payload (including auto-selected ones)
    let payloadDomain = domain;
    let payloadSubDomain = subDomain;
    let payloadProduct = product;

    // If we auto-selected domain, use that value
    if (newParentDomain !== "All Parent Domains" && hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === newParentDomain
      );
      if (selectedParentDomain && selectedParentDomain.domains.length === 1) {
        payloadDomain = selectedParentDomain.domains[0].domain;

        // If we auto-selected sub domain, use that value too
        if (selectedParentDomain.domains[0].sub_domains.length === 1) {
          payloadSubDomain =
            selectedParentDomain.domains[0].sub_domains[0].sub_domain;

          // If we auto-selected product, use that value too
          if (
            selectedParentDomain.domains[0].sub_domains[0].products.length === 1
          ) {
            payloadProduct =
              selectedParentDomain.domains[0].sub_domains[0].products[0];
          }
        }
      }
    }

    // Process search query - convert spaces to underscores and trim
    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    // Create payload with the actual values (including auto-selected ones)
    const payload = {
      parentDomain:
        newParentDomain === "All Parent Domains" ? "" : newParentDomain,
      domain: payloadDomain === "All Domains" ? "" : payloadDomain,
      subDomain: payloadSubDomain === "All Sub Domains" ? "" : payloadSubDomain,
      product: payloadProduct === "All Products" ? "" : payloadProduct,
      searchValue: processedSearchQuery,
      page: 1,
      pageSize: pageSize,
    };

    // Call API with the new payload
    fetchDataDiscovery(payload).finally(() => {
      setFilterLoading(false);
    });
  };

  // Handle domain change - cascade to sub domain and product
  const handleDomainChange = (event) => {
    const newDomain = event.target.value;
    setDomain(newDomain);

    if (newDomain === "All Domains") {
      setSubDomain("All Sub Domains");
      setProduct("All Products");
      setDomainId(null);
      setSubDomainId(null);
    } else {
      // Find related sub domains and products for this domain
      if (hierarchicalFilters && hierarchicalFilters.parent_domains) {
        const selectedParentDomain = hierarchicalFilters.parent_domains.find(
          (pd) => pd.parent_domain === parentDomain
        );

        if (selectedParentDomain) {
          const selectedDomain = selectedParentDomain.domains.find(
            (d) => d.domain === newDomain
          );

          if (selectedDomain) {
            setDomainId(selectedDomain.domain_id);
            const relatedSubDomains = selectedDomain.sub_domains.map(
              (sd) => sd.sub_domain
            );

            // Auto-select sub domain if only one option available
            if (relatedSubDomains.length === 1) {
              setSubDomain(relatedSubDomains[0]);
              setSubDomainId(selectedDomain.sub_domains[0].sub_domain_id);

              // Also auto-select product if only one option
              const selectedSubDomain = selectedDomain.sub_domains[0];
              const subDomainProducts = selectedSubDomain.products;

              if (subDomainProducts.length === 1) {
                setProduct(subDomainProducts[0]);
              } else {
                setProduct("All Products");
              }
            } else {
              setSubDomain("All Sub Domains");
              setSubDomainId(null);
              setProduct("All Products");
            }
          }
        }
      }
    }

    // Reset to page 1 when filters change
    setCurrentPage(1);

    // Make API call with new filter - show loading in contracts list area
    setFilterLoading(true);

    // Determine the actual values to send in payload (including auto-selected ones)
    let payloadSubDomain = subDomain;
    let payloadProduct = product;

    // If we auto-selected sub domain, use that value
    if (newDomain !== "All Domains" && hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === parentDomain
      );
      if (selectedParentDomain) {
        const selectedDomain = selectedParentDomain.domains.find(
          (d) => d.domain === newDomain
        );
        if (selectedDomain && selectedDomain.sub_domains.length === 1) {
          payloadSubDomain = selectedDomain.sub_domains[0].sub_domain;

          // If we auto-selected product, use that value too
          if (selectedDomain.sub_domains[0].products.length === 1) {
            payloadProduct = selectedDomain.sub_domains[0].products[0];
          }
        }
      }
    }

    // Process search query - convert spaces to underscores and trim
    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    // Create payload with the actual values (including auto-selected ones)
    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: newDomain === "All Domains" ? "" : newDomain,
      subDomain: payloadSubDomain === "All Sub Domains" ? "" : payloadSubDomain,
      product: payloadProduct === "All Products" ? "" : payloadProduct,
      searchValue: processedSearchQuery,
      page: 1,
      pageSize: pageSize,
    };

    // Call API with the new payload
    fetchDataDiscovery(payload).finally(() => {
      setFilterLoading(false);
    });
  };

  // Handle sub domain change - cascade to product
  const handleSubDomainChange = (event) => {
    const newSubDomain = event.target.value;
    setSubDomain(newSubDomain);

    if (newSubDomain === "All Sub Domains") {
      setProduct("All Products");
      setSubDomainId(null);
    } else {
      // Find related products for this sub domain
      if (hierarchicalFilters && hierarchicalFilters.parent_domains) {
        const selectedParentDomain = hierarchicalFilters.parent_domains.find(
          (pd) => pd.parent_domain === parentDomain
        );

        if (selectedParentDomain) {
          const selectedDomain = selectedParentDomain.domains.find(
            (d) => d.domain === domain
          );

          if (selectedDomain) {
            const selectedSubDomain = selectedDomain.sub_domains.find(
              (sd) => sd.sub_domain === newSubDomain
            );

            if (selectedSubDomain) {
              setSubDomainId(selectedSubDomain.sub_domain_id);
              const relatedProducts = selectedSubDomain.products;

              // Auto-select product if only one option available
              if (relatedProducts.length === 1) {
                setProduct(relatedProducts[0]);
              } else {
                setProduct("All Products");
              }
            }
          }
        }
      }
    }

    // Reset to page 1 when filters change
    setCurrentPage(1);

    // Make API call with new filter - show loading in contracts list area
    setFilterLoading(true);

    // Determine the actual values to send in payload (including auto-selected ones)
    let payloadProduct = product;

    // If we auto-selected product, use that value
    if (newSubDomain !== "All Sub Domains" && hierarchicalFilters) {
      const selectedParentDomain = hierarchicalFilters.parent_domains.find(
        (pd) => pd.parent_domain === parentDomain
      );
      if (selectedParentDomain) {
        const selectedDomain = selectedParentDomain.domains.find(
          (d) => d.domain === domain
        );
        if (selectedDomain) {
          const selectedSubDomain = selectedDomain.sub_domains.find(
            (sd) => sd.sub_domain === newSubDomain
          );
          if (selectedSubDomain && selectedSubDomain.products.length === 1) {
            payloadProduct = selectedSubDomain.products[0];
          }
        }
      }
    }

    // Process search query - convert spaces to underscores and trim
    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    // Create payload with the actual values (including auto-selected ones)
    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: newSubDomain === "All Sub Domains" ? "" : newSubDomain,
      product: payloadProduct === "All Products" ? "" : payloadProduct,
      searchValue: processedSearchQuery,
      page: 1,
      pageSize: pageSize,
    };

    // Call API with the new payload
    fetchDataDiscovery(payload).finally(() => {
      setFilterLoading(false);
    });
  };

  // Handle product change
  const handleProductChange = (event) => {
    const newProduct = event.target.value;
    setProduct(newProduct);

    // Reset to page 1 when filters change
    setCurrentPage(1);

    // Make API call with new filter - show loading in contracts list area
    setFilterLoading(true);

    // Process search query - convert spaces to underscores and trim
    const processedSearchQuery = searchQuery
      ? searchQuery.trim().replace(/\s+/g, "_")
      : "";

    // Create payload with the new value directly instead of waiting for state update
    const payload = {
      parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
      domain: domain === "All Domains" ? "" : domain,
      subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
      product: newProduct === "All Products" ? "" : newProduct,
      searchValue: processedSearchQuery,
      page: 1,
      pageSize: pageSize,
    };

    // Call API with the new payload
    fetchDataDiscovery(payload).finally(() => {
      setFilterLoading(false);
    });
  };

  // Transform API data to match the expected contract format
  const transformApiDataToContracts = (data) => {
    return data.map((item, index) => ({
      id: item.data_asset_id || item.product_id || `contract-${index}`,
      name: item.data_asset_name || item.product_name || "Unnamed Asset",
      version: item?.version || "1.0.0",
      type: item.type,
      status: "ACTIVE",
      owner: item.created_by || item.product_owner || "Unknown Owner",
      lastUpdated: item.last_modified
        ? new Date(item.last_modified).toLocaleDateString()
        : "Unknown",
      tables: [item.data_asset_name || item.product_name],
      qualityScore: item.quality_score || 0,
      description:
        item.data_assets_description ||
        item.description ||
        "No description available",
      tablesCount: 1,
      assets: [item.data_asset_name || item.product_name],
      filePath: item?.file_path,

      // Additional fields from API
      executionDate: item.execution_date,
      productName: item.product_name,
      productOwner: item.product_owner,
      dataLayer: item.data_layer,
      data_layer: item.data_layer, // Add this for ContractCard to check
      parentDomainName: item.parent_domain_name,
      domainName: item.domain_name,
      subDomainName: item.sub_domain_name,
      dqRuleCount: item.dq_rule_count,
      dqTrend: item.trend || item.dq_trend || "N/A",
      assetTrend: item.asset_trend,
      issues: item.issues,
      createdDate: item.created_date,
      profileStatus: item.profileStatus || "N/A",
      tags: item?.tags,
      productId: item.product_id || null,
      source_type: item.source_type,
      product_owner: item.product_owner,
      technical_data_steward: item.technical_data_steward,

      // Analytical Product specific fields
      overall_status: item.overall_status,
      business_function: item.business_function,
      market: item.market,
      market_country: item.market_country,
      region: item.region,
      report_owner: item.report_owner,
      report_objective: item.report_objective,
      key_decision_support: item.key_decision_support,
      report_link: item.report_link,
      report_section: item.report_section,
      report_description: item.report_description,
      report_type: item.report_type,
      domain_name: item.domain_name,
      asset_count: item.asset_count,
      logoIds: item.logoIds,
    }));
  };

  const handleReportSubscribe = (contract) => {
    if (subscribedTables.includes(contract.id)) {
      setSubscribedTables((prev) => prev.filter((id) => id !== contract.id));
    } else {
      setSelectedTable(contract);
      setShowReportSubscriptionForm(true);
    }
  };

  const handleSubscribe = () => {
    if (cartItems && cartItems.length > 0) {
      setSelectedTable(cartItems);
      setShowSubscriptionForm(true);
    }
  };

  const closeSubsciptionModal = () => {
    setFormTouched(false);
    setSubscribedTables((prev) => [...prev, selectedTable.id]);
    setShowSubscriptionForm(false);
    setShowReportSubscriptionForm(false);
    setSelectedTable(null);
    // Clear Redux cart after successful subscription
    dispatch({
      type: CLEAR_CART,
    });
    setSubscriptionForm({
      productName: "",
      projectCode: "",
      readerGroup: "",
      usageDuration: "3months",
      usageDescription: "",
      notificationEmail: "",
      acceptTerms: false,
      source: "DATAPULSE",
    });
  };

  const handleSubscriptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    let _form = {
      ...subscriptionForm,
      [name]: newValue,
    };
    // populate reader group if exists
    if (name === "productName") {
      _form.readerGroup = e.target.readerGroup || "";
      _form.source = e.target.source || "DATAPULSE";
    }
    setSubscriptionForm(_form);

    // Real-time validation for email field
    if (name === "notificationEmail" && value) {
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          notificationEmail: "Only @effem.com email addresses are allowed",
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.notificationEmail;
          return newErrors;
        });
      }
    }
  };

  const validateConfigForm = (formData = subscriptionForm) => {
    const errors = {};
    if (!formData.productName) errors.productName = "Required";
    if (!formData.readerGroup) errors.readerGroup = "Required";
    if (!formData.usageDuration) errors.usageDuration = "Required";
    if (!formData.usageDescription) errors.usageDescription = "Required";
    if (!formData.notificationEmail) {
      errors.notificationEmail = "Required";
    } else {
      // Email validation - only allow @effem.com domain
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(formData.notificationEmail)) {
        errors.notificationEmail =
          "Only @effem.com email addresses are allowed";
      }
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubscriptionSubmit = async () => {
    setSubscriptionLoading(true);
    const trimmedForm = {
      ...subscriptionForm,
      productName: subscriptionForm.productName.trim(),
      projectCode: subscriptionForm.projectCode?.trim() || "",
      readerGroup: subscriptionForm.readerGroup.trim(),
      usageDescription: subscriptionForm.usageDescription.trim(),
      notificationEmail: subscriptionForm.notificationEmail.trim(),
      source: subscriptionForm.source?.toUpperCase() || "DATAPULSE",
    };

    setSubscriptionForm(trimmedForm);
    setFormTouched(true);
    // Now do full validation (including email format)
    if (!validateConfigForm(trimmedForm)) return;

    const requestDetails = {
      requestedBy: localStorage.getItem("userId"),
      usageDuration: trimmedForm.usageDuration,
      usageDescription: trimmedForm.usageDescription,
      readerGroup: trimmedForm.readerGroup,
      productName: trimmedForm.productName,
      projectCode: trimmedForm.projectCode || "",
      notificationEmail: trimmedForm.notificationEmail,
      source: trimmedForm.source,
    };

    const requestPayload = {
      dataAssetId: cartItems?.map((item) => item.id) || [],
      requestDetails: requestDetails,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/subscription-request`,
        requestPayload
      );

      if (response.status === 200 || response.status === 201) {
        closeSubsciptionModal();
        setSubscriptionLoading(false);
      }

      toast.success("Subscription to the asset configured successfully!");
    } catch (error) {
      toast.error("Failed to subscribe to the asset. Please try again later.");
      setSubscriptionLoading(false);
    }
  };
  const handleReportSubscriptionSubmit = async () => {
    const trimmedForm = {
      ...subscriptionForm,
      productName: subscriptionForm.productName.trim(),
      projectCode: subscriptionForm.projectCode?.trim() || "",
      readerGroup: subscriptionForm.readerGroup.trim(),
      usageDescription: subscriptionForm.usageDescription.trim(),
      notificationEmail: subscriptionForm.notificationEmail.trim(),
      source: subscriptionForm.source?.toUpperCase() || "DATAPULSE",
    };

    setSubscriptionForm(trimmedForm);
    setFormTouched(true);
    // Now do full validation (including email format)
    if (!validateConfigForm(trimmedForm)) return;

    const requestDetails = {
      requestedBy: localStorage.getItem("userId"),
      usageDuration: trimmedForm.usageDuration,
      usageDescription: trimmedForm.usageDescription,
      readerGroup: trimmedForm.readerGroup,
      productName: trimmedForm.productName,
      projectCode: trimmedForm.projectCode || "",
      notificationEmail: trimmedForm.notificationEmail,
      source: trimmedForm.source,
    };

    const requestPayload = {
      dataAssetId: [selectedTable.id],
      requestDetails: requestDetails,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/subscription-request`,
        requestPayload
      );

      if (response.status === 200 || 201) {
        if (selectedTable) {
          closeSubsciptionModal();
        }
      }

      toast.success("Subscription to the asset configured successfully!");
    } catch (error) {
      toast.error("Failed to subscribe to the asset. Please try again later.");
    }
  };

  const handleAlertPreferenceChange = (preference) => {
    setSubscriptionForm((prev) => ({
      ...prev,
      alertPreferences: {
        ...prev.alertPreferences,
        [preference]: !prev.alertPreferences[preference],
      },
    }));
  };

  const handleViewProfile = (contract) => {
    navigate(`/onboarding/data-profiling/${contract.tables.join(",")}`);
  };

  const handleViewContract = async (contract) => {
    if (contract.id) {
      setSelectedContractForView(contract);
      setShowContractModal(true);

      // Fetch contract details from API
      await fetchContractDetails(contract.id);
    }
  };

  // Fetch contract details from API
  const fetchContractDetails = async (dataAssetId) => {
    if (!dataAssetId) {
      return null;
    }

    try {
      setContractLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/view-contracts/${dataAssetId}`
      );

      if (response.data && response.data.status === "success") {
        setContractDetails(response.data.data);
        return response.data.data;
      } else {
        setContractDetails(null);
        return null;
      }
    } catch (err) {
      console.error("Error fetching contract details:", err);
      setContractDetails(null);
      return null;
    } finally {
      setContractLoading(false);
    }
  };

  const handleViewProduct = async (contract) => {
    if (contract.productId) {
      // Check if we already have this product's details
      const existingProduct = productDetails.find(
        (p) => p.productId === contract.productId
      );

      if (existingProduct) {
        // Open product details popup with existing data
        setSelectedProductForView(existingProduct);
        setShowProductModal(true);
      } else {
        setProductLoading(true); // Start loading for product details
        const productData = await fetchProductDetails(contract.productId);

        if (productData) {
          // Open product details popup with fetched data
          setSelectedProductForView(productData);
          setShowProductModal(true);
        } else {
          // TODO: Show error message to user
        }
      }
    } else {
      // TODO: Show error message to user
    }
  };

  const handleViewAssetDetails = async (contract) => {
    if (contract.id) {
      const existingAsset =
        assetData?.data_asset_id === contract.id ? assetData : null;

      if (existingAsset) {
        setSelectedAssetForView(contract);
        setShowAssetModal(true);
      } else {
        setSelectedAssetForView(contract);
        setShowAssetModal(true);

        const assetDetails = await fetchAssetDetails(contract.id);

        if (assetDetails) {
          setAssetData(assetDetails);
        }
      }
    }
  };

  const handleViewResult = async (contract) => {
    // Open result details popup
    setSelectedResultForView(contract);
    setShowResultModal(true);
    setActiveResultTab("profile"); // Default to profile tab

    // Fetch profiling results for this contract
    if (contract.productId) {
      await fetchProfilingResults(contract.productId);

      // Also fetch DQ results for the quality tab
      if (contract.id) {
        await fetchDQResults(contract.productId, contract.id);
      }
    } else {
    }
  };

  const handleViewLineage = (contract) => {
    // Open lineage modal with contract details
    setSelectedLineageForView(contract);
    setShowLineageModal(true);
  };

  const handleLineageTransformation = (contract) => {
    setTransformLineageAsset(contract.name);
  };

  // Fetch product details from edit-form API
  const fetchProductDetails = async (productId) => {
    if (!productId) {
      return null;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/edit-form/${productId}`
      );

      if (response.data && response.data.productId) {
        // Add to productDetails array if not already present
        setProductDetails((prev) => {
          const existing = prev.find((p) => p.productId === productId);
          if (!existing) {
            return [...prev, response.data];
          }
          return prev;
        });

        return response.data;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    } finally {
      setProductLoading(false); // End loading for product details
    }
  };

  // Fetch profiling results from API
  const fetchProfilingResults = async (productId) => {
    if (!productId) {
      return null;
    }

    try {
      setProfilingLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/profiling_results/${productId}`
      );

      if (response.data && response.data.profiling_results) {
        setProfilingResults(response.data);
        return response.data;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    } finally {
      setProfilingLoading(false);
    }
  };

  // Fetch DQ results from API
  const fetchDQResults = async (productId, dataAssetId) => {
    if (!productId || !dataAssetId) {
      return null;
    }

    try {
      setDqLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/runQuality/ruleStatus/${productId}`
      );

      if (response.data && Array.isArray(response.data)) {
        // Find the asset with matching data_asset_id
        const matchingAsset = response.data.find(
          (asset) => asset.data_asset_id === dataAssetId
        );

        if (matchingAsset) {
          setDqResults(matchingAsset);
          return matchingAsset;
        } else {
          setDqResults(null);
          return null;
        }
      } else {
        return null;
      }
    } catch (err) {
      return null;
    } finally {
      setDqLoading(false);
    }
  };

  // Fetch asset details from API
  const fetchAssetDetails = async (assetId) => {
    if (!assetId) {
      return null;
    }

    try {
      setAssetLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/assets/${assetId}`
      );

      if (response.data) {
        setAssetData(response.data);
        return response.data;
      } else {
        return null;
      }
    } catch (err) {
      return null;
    } finally {
      setAssetLoading(false);
    }
  };

  const handleAssetSelectionChange = (assetIds) => {
    setSelectedAssets(assetIds);
  };

  const getFilteredContracts = () => {
    const dataToUse =
      filteredData && filteredData.length > 0 ? filteredData : apiData;

    if (!dataToUse || !Array.isArray(dataToUse)) {
      return [];
    }

    let contracts = transformApiDataToContracts(dataToUse);

    contracts.sort((a, b) => {
      if (a.type === "ANALYTICAL_PRODUCT" && b.type !== "ANALYTICAL_PRODUCT") {
        return -1;
      }
      if (a.type !== "ANALYTICAL_PRODUCT" && b.type === "ANALYTICAL_PRODUCT") {
        return 1;
      }
      return 0;
    });

    return contracts;
  };
  const filteredContracts = getFilteredContracts();
  const myContracts = filteredContracts;
  const mySubscriptions = filteredContracts;

  const getFilterOptions = useMemo(() => {
    // Start with ALL available options initially
    let availableOptions = { ...filterOptions };

    // Use the hierarchical filters data from API for cascading logic
    if (hierarchicalFilters && hierarchicalFilters.parent_domains) {
      // Apply cascading logic to filter options based on current selections
      if (parentDomain !== "All Parent Domains") {
        // Find the selected parent domain
        const selectedParentDomain = hierarchicalFilters.parent_domains.find(
          (pd) => pd.parent_domain === parentDomain
        );

        if (selectedParentDomain) {
          // Get ONLY domains for this parent domain
          const domains = selectedParentDomain.domains.map((d) => d.domain);
          availableOptions.domains = domains;

          // If domain is selected, get ONLY sub domains for this domain
          if (domain !== "All Domains") {
            const selectedDomain = selectedParentDomain.domains.find(
              (d) => d.domain === domain
            );
            if (selectedDomain) {
              const subDomains = selectedDomain.sub_domains.map(
                (sd) => sd.sub_domain
              );
              availableOptions.subDomains = subDomains;

              // If sub domain is selected, get ONLY products for this sub domain
              if (subDomain !== "All Sub Domains") {
                const selectedSubDomain = selectedDomain.sub_domains.find(
                  (sd) => sd.sub_domain === subDomain
                );
                if (selectedSubDomain) {
                  availableOptions.products = selectedSubDomain.products;
                }
              }
            }
          }
        }
      }
    }

    return availableOptions;
  }, [hierarchicalFilters]);

  // Handle tab change - reset pagination
  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    setCurrentPage(1);
  };

  // Reset all filters to default values
  const handleResetFilters = () => {
    setFilterReset(true);
    setParentDomain("All Parent Domains");
    setParentDomainId(null);
    setDomain("All Domains");
    setDomainId(null);
    setSubDomain("All Sub Domains");
    setSubDomainId(null);
    setProduct("All Products");
    setSearchQuery("");
    setCurrentPage(1);
    // Reset ALL filters state
    setAllSelectedFilters({
      parentDomain: [],
      domain: [],
      subDomain: [],
      product: [],
      productDataLayer: [],
      lineOfBusiness: [],
      reportType: [],
      cloudProvider: [],
      tags: [],
      parentRegion: [],
      region: [],
      country: [],
      expectedUserBase: [0, 10000],
      dqRating: [0, 100],
      productOwner: [],
      assetSource: [],
      reportOwner: [],
      searchBy: "tables",
      tables: [],
      columns: [],
    });
    fetchDataDiscovery();
  };
 useEffect(() => {
  const fetchMaxHits = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/asset-usage/max`
      );
      if (response.data !== undefined && response.data !== null) {
        setMaxHits(Number(response.data));
      }
    } catch (err) {
      console.error("Failed to fetch max hits:", err);
    }
  };
  fetchMaxHits();
}, []);

  useEffect(() => {
    if (!loading) return;

    const texts = [
      "Hang tight! The resources are loading...",
      "Fetching...",
      "Analyzing...",
      "Almost there...",
    ];
    let index = 0;

    setLoadingText(texts[index]);

    const interval = setInterval(() => {
      index = (index + 1) % texts.length;
      setLoadingText(texts[index]);
    }, 5000);

    return () => clearInterval(interval);
  }, [loading]);

  if (loading) {
    return (
          <div className="relative bg-white flex items-center justify-center z-50 h-[80vh]">
  <div className="flex flex-col items-center space-y-3">
    <img src={heartLoading} alt="Loading..." width={200} />
    <span className="text-gray-700 text-[20px] text-center">
      Hang tight! The resources are loading.....
    </span>
  </div>
</div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => {
              setError(null);
              fetchDataDiscovery();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-[#f9fafb]">
      {/* Filter Drawer */}

      <FilterDrawer
        open={showFilters}
        onClose={() => setShowFilters(false)}
        parentDomain={parentDomain}
        domain={domain}
        selectedTab={selectedTab}
        subDomain={subDomain}
        product={product}
        filterOptions={getFilterOptions}
        hierarchicalFilters={hierarchicalFilters}
        handleParentDomainChange={handleParentDomainChange}
        handleDomainChange={handleDomainChange}
        handleSubDomainChange={handleSubDomainChange}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        handleSearchSubmit={handleSearchSubmit}
        handleProductChange={handleProductChange}
        handleResetFilters={handleResetFilters}
        handleApplyAllFilters={handleApplyAllFilters}
        allSelectedFilters={allSelectedFilters}
      />

      {/* Main Content */}
      <div className="p-1 ">
        <div
          style={{
            width: "100%",
            backgroundColor: "#f9fafb",
            marginLeft: "10px",
          }}
        >
          {/* Header Row with Title and Filter Button */}
          <div
            style={{
              display: "flex", justifyContent: "space-between", marginBottom: "16px", alignItems: "flex-start",
            }}
          >
            <div>

              <div className="font-bold font-family-poppins pt-2 text-[24px] text-[#424242]">

                {selectedTab === "assets" && "Asset Discovery"}

                {selectedTab === "report" && "Report Discovery"}

                {selectedTab === "glossary" && "Glossary Discovery"}

                {selectedTab === "CUSTOM_TAB" && "KPI Discovery"}
              </div>

              <p className="pb-6">

                {selectedTab === "assets" && "Discover and analyze Datasets linked to parent domains, domains, subdomains, and products."}

                {selectedTab === "report" && "Discover and analyze Reports linked to parent domains, domains, subdomains, and products."}

                {selectedTab === "glossary" && "Explore business terms, definitions, and data standards across your organization."}

                {selectedTab === "CUSTOM_TAB" && "Discover and analyze Key Performance Indicators (KPIs) across your organization."}
              </p>
            </div>


            {selectedTab !== "CUSTOM_TAB" && selectedTab !== "glossary" && (
              <button
                onClick={() => setShowFilters(true)}
                className="flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg border transition-colors h-[45px] whitespace-nowrap bg-[#bb1ccc] text-white border-[#bb1ccc] text-[14px]"
              >
                <Filter className="h-4 w-4" />
                Filters
              </button>
            )}
          </div>


          <div style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
            <button
              onClick={() => {
                setSelectedTab("assets");
                setCurrentPage(1);
                setActiveTab("all");
                setParentDomain("All Parent Domains");
                setDomain("All Domains");
                setSubDomain("All Sub Domains");
                setProduct("All Products");
                setSearchQuery("");
              }}
              style={{
                padding: "8px 16px",
                backgroundColor:
                  selectedTab === "assets" ? "#bb1ccc" : "#F3F4F6",
                color: selectedTab === "assets" ? "#fff" : "#1f0b0bff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                justifyItems: "center",
              }}
            >
              <Database className="h-5" />
              <div>Assets Discovery </div>
            </button>
            <button
              onClick={() => {
                setSelectedTab("report");
                setCurrentPage(1);
                setActiveTab("all");
                setParentDomain("All Parent Domains");
                setDomain("All Domains");
                setSubDomain("All Sub Domains");
                setProduct("All Products");
                setSearchQuery("");
              }}
              style={{
                padding: "8px 16px",
                backgroundColor:
                  selectedTab === "report" ? "#bb1ccc" : "#F3F4F6",
                color: selectedTab === "report" ? "#fff" : "#1f0b0bff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                justifyItems: "center",
              }}
            >
              <FileText className="h-5" />
              <div>Report Discovery</div>
            </button>
            <button
              onClick={() => {
                setSelectedTab("CUSTOM_TAB");
                setCurrentPage(1);
                setActiveTab("custom");
                setSearchQuery("");
              }}
              className={`px-4 py-2 rounded cursor-pointer border-none flex items-center
 
    ${selectedTab === "CUSTOM_TAB"
                  ? "bg-[#bb1ccc] text-white"
                  : "bg-[#F3F4F6] text-[#1f0b0bff]"
                }
  `}
            >
              <Target className="h-5 " />
              <div>KPI Discovery</div>
            </button>
            {isGrossaryFeatureEnabled  && (
              <button
                onClick={() => {
                  setSelectedTab("glossary");
                  setCurrentPage(1);
                  setActiveTab("all");
                }}
                style={{
                  padding: "8px 16px",
                  backgroundColor: selectedTab === "glossary" ? "#bb1ccc" : "#F3F4F6",
                  color: selectedTab === "glossary" ? "#fff" : "#1f0b0bff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  justifyItems: "center"
                }}
              >
                <BookOpen className="h-5" />
                <div>Glossary Discovery</div>
              </button>
            )}
          </div>
          <div className="card">
            <ContractTabs
              activeTab={activeTab}
              setActiveTab={handleTabChange}
              selectedTab={selectedTab}
            />
            {/* ADD SEARCH BAR HERE*/}
            {selectedTab !== "CUSTOM_TAB" && selectedTab !== "glossary" && (
              <div
                style={{
                  padding: "12px 20px",
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #E5E7EB",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="flex items-center gap-2">
                    {/* Search Input */}
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        flex: 1,
                        maxWidth: "550px",
                      }}
                    >
                      <svg
                        style={{
                          position: "absolute",
                          left: "10px",
                          width: "16px",
                          height: "16px",
                          color: "#9CA3AF",
                        }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={handleSearchSubmit}
                        placeholder="Search by Asset, Product, Parent Domain, Domain, Subdomain, Column"
                        style={{
                          width: "550px",
                          padding: "6px 35px 6px 35px",
                          fontSize: "13px",
                          color: "#374151",
                          backgroundColor: "#fff",
                          border: "1px solid #D1D5DB",
                          borderRadius: "6px",
                          outline: "none",
                          transition: "all 0.2s",
                          height: "34px",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#bb1ccc";
                          e.target.style.boxShadow = "0 0 0 1px #bb1ccc";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#D1D5DB";
                          e.target.style.boxShadow = "none";
                        }}
                      />
                      {searchQuery && (
                        <button
                          onClick={() => {
                            setSearchQuery("");
                            setCurrentPage(1);

                            // Only update search, keep all other filters
                            const payload = {
                              page: 1,
                              pageSize: pageSize,
                              parentDomain:
                                allSelectedFilters.parentDomain || [],
                              domain: allSelectedFilters.domain || [],
                              subDomain: allSelectedFilters.subDomain || [],
                              product: allSelectedFilters.product || [],
                              searchValue: "", // Clear search only
                              productDataLayer:
                                allSelectedFilters.productDataLayer || [],
                              lineOfBusiness:
                                allSelectedFilters.lineOfBusiness || [],
                              reportType: allSelectedFilters.reportType || [],
                              cloudProvider:
                                allSelectedFilters.cloudProvider || [],
                              tags: allSelectedFilters.tags || [],
                              searchBy: allSelectedFilters.searchBy || "tables",
                              tables: allSelectedFilters.tables || [],
                              columns: allSelectedFilters.columns || [],
                              cdeEnabled:
                                allSelectedFilters.cdeEnabled || false,
                              marketRegion: allSelectedFilters.region || [],
                              parentRegion:
                                allSelectedFilters.parentRegion || [],
                              country: allSelectedFilters.country || [],
                              expectedUserBase:
                                allSelectedFilters.expectedUserBase || [
                                  0, 10000,
                                ],
                              dqRating: allSelectedFilters.dqRating || [0, 100],
                              productOwner:
                                allSelectedFilters.productOwner || [],
                              assetSource: allSelectedFilters.assetSource || [],
                              reportOwner: allSelectedFilters.reportOwner || [],
                            };

                            fetchDataDiscovery(payload);
                          }}
                          style={{
                            position: "absolute",
                            right: "8px",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#9CA3AF",
                            transition: "color 0.2s",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.color = "#374151")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.color = "#9CA3AF")
                          }
                        >
                          <svg
                            width="14"
                            height="14"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                          >
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                          </svg>
                        </button>
                      )}
                    </div>

                    {/* Reset Button */}
                    <button
                      // For the X button inside search input:
                      onClick={() => {
                        setSearchQuery("");
                        setCurrentPage(1);

                        // Only update search, keep all other filters
                        const payload = {
                          page: 1,
                          pageSize: pageSize,
                          parentDomain: allSelectedFilters.parentDomain || [],
                          domain: allSelectedFilters.domain || [],
                          subDomain: allSelectedFilters.subDomain || [],
                          product: allSelectedFilters.product || [],
                          searchValue: "", // Clear search only
                          productDataLayer:
                            allSelectedFilters.productDataLayer || [],
                          lineOfBusiness:
                            allSelectedFilters.lineOfBusiness || [],
                          reportType: allSelectedFilters.reportType || [],
                          cloudProvider: allSelectedFilters.cloudProvider || [],
                          tags: allSelectedFilters.tags || [],
                          searchBy: allSelectedFilters.searchBy || "tables",
                          tables: allSelectedFilters.tables || [],
                          columns: allSelectedFilters.columns || [],
                          cdeEnabled: allSelectedFilters.cdeEnabled || false,
                          marketRegion: allSelectedFilters.region || [],
                          parentRegion: allSelectedFilters.parentRegion || [],
                          country: allSelectedFilters.country || [],
                          expectedUserBase:
                            allSelectedFilters.expectedUserBase || [0, 10000],
                          dqRating: allSelectedFilters.dqRating || [0, 100],
                          productOwner: allSelectedFilters.productOwner || [],
                          assetSource: allSelectedFilters.assetSource || [],
                          reportOwner: allSelectedFilters.reportOwner || [],
                        };

                        fetchDataDiscovery(payload);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 14px",
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#374151",
                        backgroundColor: "#fff",
                        border: "1px solid #D1D5DB",
                        borderRadius: "6px",
                        cursor: "pointer",
                        transition: "all 0.2s",
                        height: "34px",
                        whiteSpace: "nowrap",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#F9FAFB";
                        e.currentTarget.style.borderColor = "#9CA3AF";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#fff";
                        e.currentTarget.style.borderColor = "#D1D5DB";
                      }}
                    >
                      <RotateCcw style={{ width: "14px", height: "14px" }} />
                      Reset
                    </button>
                  </div>
                  {/* {selectedTab === "assets" && activeTab === "all" && (
                    <button
                      disabled={!(cartItems?.length > 0)}
                      onClick={handleSubscribe}
                      className={`bg-[#E31837] text-white text-[13px] h-[35px] rounded-md px-5 py-2 flex items-center gap-1
                      ${cartItems?.length > 0
                          ? "cursor-pointer"
                          : "cursor-not-allowed opacity-60"
                        }
                    `}
                    >
                      <ShoppingCart className="h-[30px]" />
                      <span>checkout ({cartItems?.length || 0})</span>
                    </button>
                  )} */}
                </div>
              </div>
            )}
            <div className="card-body">
              {selectedTab === "CUSTOM_TAB" ? (
                <KpiDiscovery
                  tableData={kpiData}
                  totalCount={kpiTotalCount}
                  onSortChange={handleKpiSortChange}
                  sortConfig={kpiSortConfig}
                />
              ) : selectedTab === "glossary" ? (
                <GlossaryDiscovery />) :
                (
                  <ContractList
                    activeTab={activeTab}
                    filteredContracts={filteredContracts}
                    mySubscriptions={mySubscriptions}
                    myContracts={myContracts}
                    reports={solutionData}
                    subscribedTables={subscribedTables}
                    handleSubscribe={handleSubscribe}
                    handleReportSubscribe={handleReportSubscribe}
                    handleViewProfile={handleViewProfile}
                    handleViewContract={handleViewContract}
                    handleViewProduct={handleViewProduct}
                    handleViewAssetDetails={handleViewAssetDetails}
                    handleViewResult={handleViewResult}
                    handleViewLineage={handleViewLineage}
                    handleLineageTransformation={handleLineageTransformation}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    loading={loading}
                    searchLoading={searchLoading}
                    filterLoading={filterLoading}
                    setAssetName={setAssetName}
                    selectedAssetList={cartItems}
                    setSelectedAssetList={null}
                    selectedTab={selectedTab}
                    maxHits={maxHits}
                  />
                )}
            </div>
          </div>

          <Toaster position="top-right" />
          {showSubscriptionForm && selectedTable && (
            <SubscriptionModal
              selectedAsset={cartItems}
              subscriptionForm={subscriptionForm}
              closeSubsciptionModal={closeSubsciptionModal}
              handleSubscriptionSubmit={handleSubscriptionSubmit}
              handleSubscriptionChange={handleSubscriptionChange}
              setShowSubscriptionForm={setShowSubscriptionForm}
              showSubscriptionForm={showSubscriptionForm}
              allFieldsValid={allFieldsValid}
              formTouched={formTouched}
              formErrors={formErrors}
              products={subscribableProducts}
              loading={subscriptionLoading}
            />
          )}

          {showReportSubscriptionForm && selectedTable && (
            <ReportSubscriptionModal
              selectedAsset={selectedTable}
              subscriptionForm={subscriptionForm}
              closeSubsciptionModal={closeSubsciptionModal}
              handleSubscriptionSubmit={handleReportSubscriptionSubmit}
              handleSubscriptionChange={handleSubscriptionChange}
              setShowSubscriptionForm={setShowReportSubscriptionForm}
              showSubscriptionForm={showReportSubscriptionForm}
              allFieldsValid={allFieldsValid}
              formTouched={formTouched}
              formErrors={formErrors}
              products={subscribableProducts}
              loading={subscriptionLoading}
            />
          )}

          {showContractModal && selectedContractForView && (
            <ContractDetailModal
              selectedContractForView={selectedContractForView}
              contractDetails={contractDetails}
              contractLoading={contractLoading}
              setShowContractModal={setShowContractModal}
              onClose={() => {
                setShowContractModal(false);
                setSelectedContractForView(null);
                setContractDetails(null);
              }}
            />
          )}

          {/* Product Details Modal */}
          <ProductModal
            showProductModal={showProductModal}
            selectedProductForView={selectedProductForView}
            productLoading={productLoading}
            setShowProductModal={setShowProductModal}
            setSelectedProductForView={setSelectedProductForView}
          />

          {/* Result Details Modal */}
          <ResultsModal
            showResultModal={showResultModal}
            selectedResultForView={selectedResultForView}
            activeResultTab={activeResultTab}
            profilingLoading={profilingLoading}
            profilingResults={profilingResults}
            dqLoading={dqLoading}
            dqResults={dqResults}
            setShowResultModal={setShowResultModal}
            setSelectedResultForView={setSelectedResultForView}
            setActiveResultTab={setActiveResultTab}
            assetName={assetName}
            handleViewResult={handleViewResult}
          />

          {/* Asset Details Modal */}
          <AssetDetailsModal
            showAssetModal={showAssetModal}
            selectedAssetForView={selectedAssetForView}
            assetLoading={assetLoading}
            assetData={assetData}
            searchQuery={searchQuery}
            setShowAssetModal={setShowAssetModal}
            setSelectedAssetForView={setSelectedAssetForView}
            setAssetData={setAssetData}
            data={profilingResults}
            showResultModal={showResultModal}
            selectedResultForView={selectedResultForView}
            activeResultTab={activeResultTab}
            profilingLoading={profilingLoading}
            profilingResults={profilingResults}
            dqLoading={dqLoading}
            dqResults={dqResults}
            setShowResultModal={setShowResultModal}
            setSelectedResultForView={setSelectedResultForView}
            setActiveResultTab={setActiveResultTab}
            assetName={assetName}
            
          />

          {/* Lineage Modal */}
          <LineageModal
            showLineageModal={showLineageModal}
            selectedLineageForView={selectedLineageForView}
            setShowLineageModal={setShowLineageModal}
            setSelectedLineageForView={setSelectedLineageForView}
          />

          {/* Lineage Transformation */}
          {transformLineageAsset && (
            <LineageTransformationModal
              assetName={transformLineageAsset}
              handleClose={() => setTransformLineageAsset(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
